import NextLink from 'next/link'
import { useRouter } from 'next/router'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import type { NavItem } from '@/components/common/NavTabs/navItemsConfig'

const NavTabs = ({ tabs }: { tabs: NavItem[] }) => {
  const router = useRouter()
  const activeHref = tabs.map((tab) => tab.href).includes(router.pathname) ? router.pathname : tabs[0]?.href
  const query = router.query.safe ? { safe: router.query.safe } : undefined

  // Mounting Tabs with value=undefined (tabs still loading) locks Base UI into uncontrolled mode
  // and the active tab is never highlighted once the tabs arrive.
  if (!tabs.length) return null

  return (
    <Tabs value={activeHref}>
      <TabsList variant="underline" tone="brand">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.href}
            value={tab.href}
            tabIndex={0}
            nativeButton={false}
            className="whitespace-nowrap"
            render={<NextLink href={{ pathname: tab.href, query }} />}
          >
            {tab.label}
            {tab.tag}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}

export default NavTabs
